export const determineStatus = percent => {
  if (percent > 85 && percent <= 100) return 'warning';
  if (percent > 100) return 'over';
  return 'compliant';
};
